let recognizer = null;
const speechsdk = require('microsoft-cognitiveservices-speech-sdk');

export default class MssttSpeechProvider {
	init(config) {
		this.config = config;
	}

	initMicRecognition(language) {
		const speechConfig = speechsdk.SpeechConfig.fromSubscription(this.config.AzureApiKey, this.config.AzureRegion);
		speechConfig.speechRecognitionLanguage = language || 'en-US';
	
		const audioConfig = speechsdk.AudioConfig.fromDefaultMicrophoneInput();
		recognizer = new speechsdk.SpeechRecognizer(speechConfig, audioConfig);
	
		return recognizer;
	}
	
	startMicRecognition(callback, once, language) {
		if (__DEBUG__)
			console.log(`%cStart MS Speech-to-text speech recognition`, 'padding: 4px; background: #5599ff; color: #333');
	
		this.stopMicRecognition();
		this.initMicRecognition(language);
	
		if (__DEBUG__)
			window.recognizer = recognizer;
	
		const processResult = (result, status) => {
			if (result?.text) {
				const response = {
					text: result?.text,
					status,
					recognizing: status === 0,
					result
				};
	
				if (__DEBUG__)
					console.log(`%cRecognized`, `padding: 4px; background: ${response.recognizing ? '#dedede' : '#5599ff'}; color: #333`, response);
	
				if (callback)
					callback(response);
			}
		}
	
		if (once) {
			recognizer.recognizeOnceAsync(result => {
				processResult(result, 1);
				recognizer.close();
				recognizer = null;
			});
		} else {
			recognizer.startContinuousRecognitionAsync();
			recognizer.recognizing = (sender, e) => processResult(e?.result, 0);
			recognizer.recognized = (sender, e) => processResult(e?.result, 1);
		}
	}
	
	stopMicRecognition() {
		if (recognizer) {
			recognizer.stopContinuousRecognitionAsync();
			recognizer.close();
			recognizer = null;
		}
	}
}